import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import ResourceModel from "../Models/ResourceModel";
import ResourcesService from "../Services/ResourcesService";
import { ImageUpload } from "./ImageUpload";

interface ResourceModalProps {
  resource: ResourceModel;
  afterSave: Function;
  afterCancel: Function;
}

const ResourceModal = (props: ResourceModalProps) => {
  const { instance } = useMsal();

  const [visible, setVisible] = useState<boolean>(true);
  const [resource, setResource] = useState<ResourceModel>(props.resource);

  const resourcesService = useMemo(
    () => new ResourcesService(instance),
    [instance],
  );

  const loadImage = useCallback(
    async (id: number) => {
      try {
        const image = await resourcesService.getImage(id);

        setResource((prevState) => ({
          ...prevState,
          image: image,
        }));
      } catch (error) {
        toast.error("Fout bij het ophalen van de data.");
      }
    },
    [resourcesService],
  );

  const modalToggle = () => {
    setVisible((visible) => {
      return !visible;
    });

    props.afterCancel();
  };

  const modalSave = async () => {
    try {
      const error = await resourcesService.upsert(resource);

      if (error === undefined) {
        setVisible(false);
        props.afterSave();
      } else {
        toast.error(error);
      }
    } catch (error) {
      toast.error("Fout bij het ophalen van de data.");
    }
  };

  useEffect(() => {
    if (resource.id) loadImage(resource.id);
  }, [props.resource.id]);

  return (
    <>
      <Modal isOpen={visible} toggle={modalToggle} size="xl">
        <ModalHeader toggle={modalToggle}>Apparatuur</ModalHeader>
        <ModalBody>
          <form>
            <div className="form-group">
              <label className="" htmlFor="codeField">
                Nummer
              </label>
              <input
                type="text"
                className="form-control"
                id="codeField"
                defaultValue={resource.code}
                onChange={(e) =>
                  setResource({
                    ...resource,
                    code: e.target.value,
                  })
                }
              />
            </div>
            <div className="form-group">
              <label className="" htmlFor="codeField">
                Naam
              </label>
              <input
                type="text"
                className="form-control"
                id="codeField"
                defaultValue={resource.name}
                onChange={(e) =>
                  setResource({
                    ...resource,
                    name: e.target.value,
                  })
                }
              />
            </div>
            <div className="form-group">
              <label className="" htmlFor="codeField">
                Omschrijving
              </label>
              <textarea
                className="form-control my-1 mr-sm-2"
                title="Opmerkingen"
                style={{ height: "200px" }}
                onChange={(e) =>
                  setResource({
                    ...resource,
                    description: e.target.value,
                  })
                }
                value={resource.description}
              ></textarea>
            </div>
            <div className="form-group">
              <label className="" htmlFor="codeField">
                Foto
              </label>
              <ImageUpload
                image={resource.image}
                fileChanged={(e: File) =>
                  setResource({
                    ...resource,
                    image: e,
                  })
                }
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={modalSave}>
            Bewaren
          </Button>{" "}
          <Button color="secondary" onClick={modalToggle}>
            Sluiten
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ResourceModal;
